import { createActions } from 'redux-actions';

export const { loadFeatures, loadedFeatures } = createActions(
  'LOAD_FEATURES',
  'LOADED_FEATURES',
);
